import client from "services/ngage/api-client";
import AuthCredentials from "types/AuthCredentials";
import {AuthResult, TwoFactorQRCodeResult, TwoFactorRecoveryCodesResult} from "types/AuthResult";

/**
 * Obtain a CSRF token cookie
 */
function csrf() {
    return client.get('/auth/csrf-cookie');
}

/**
 * Attempt to log in as a user
 */

type LoginResponse = {
    two_factor: boolean
    operator_access: boolean
}

async function login({email, password, remember}: AuthCredentials) {
    try {
        await csrf();

        const response = await client.post<LoginResponse>('/auth/login', {email, password, remember});

        return {
            status: 'success',
            ...response.data
        } as AuthResult;

    } catch (error: any) {
        let message = (error.response.status === 422)?
            error.response.data.errors.email[0] :
            "There was a network error; please contact customer support for assistance"

        return {status: 'failed', message} as AuthResult
    }
}

/**
 * Attempt to log out as the current user
 */
function logout() {
    return client.post('/auth/logout');
}

/**
 * 2FA - Challenge
 */
async function twoFactorChallenge(code: string) {
    const response = await client.post('/auth/two-factor-challenge', {code});
    return response.status === 200;
}

/**
 * 2FA - Recovery
 */
async function twoFactorRecovery(code: string) {
    const response = await client.post('/auth/two-factor-challenge', {recovery_code: code});
    return response.status === 200;
}

/**
 * 2FA - Enable
 */
async function twoFactorEnable() {
    const response = await client.post('/auth/user/two-factor-authentication');
    return response.status === 200;
}

/**
 * 2FA - Create QR code
 */
async function twoFactorCreateQRCode() {
    return (await client.get<TwoFactorQRCodeResult>('/auth/user/two-factor-qr-code')).data;
}

/**
 * 2FA - Confirm code
 */
async function twoFactorConfirmCode(code: string) {
    const response = await client.post('/auth/user/confirmed-two-factor-authentication', {code});
    return response.status === 200;
}

/**
 * 2FA - Create QR code
 */

async function twoFactorRecoveryCodes() {
    return (await client.get<TwoFactorRecoveryCodesResult>('/auth/user/two-factor-recovery-codes')).data;
}

/**
 * 2FA - Regenerate recovery codes
 */
async function twoFactorRegenerateRecoveryCodes() {
    await client.post('/auth/user/two-factor-recovery-codes');
}

/**
 * 2FA - Disable
 */
async function twoFactorDisable() {
    await client.delete('/auth/user/two-factor-authentication');
}

const auth = {
    csrf,
    login,
    logout,
    twoFactorChallenge,
    twoFactorRecovery,
    twoFactorEnable,
    twoFactorCreateQRCode,
    twoFactorConfirmCode,
    twoFactorRecoveryCodes,
    twoFactorRegenerateRecoveryCodes,
    twoFactorDisable,
}

export default auth;